<div class="reward-page__container xy-container">
  <div class="reward-page__content" *ngIf="viewMode$ | async as viewMode">
    <!-- TITLE-->
    <div
      [ngSwitch]="viewMode==='available'"
      class="reward-title"
      style="width: 100%"
    >
      <ng-container *ngSwitchCase="true">
        <span class="title-3">Premi</span>
        <p>Puoi ottenere questi premi in cambio dei tuoi punti accumulati dalle risposte ai sondaggi.</p>
        <p>Controlla questa pagina per restare informato sui nuovi premi!</p>
      </ng-container>
      <ng-container *ngSwitchCase="false">
        <span class="title-3">I tuoi Premi</span>
        <p>Questi sono i premi che hai ottenuto in passato</p>
      </ng-container>
    </div>

    <!-- BUTTON SWITCH -->
    <div
      class="reward-mode-switch"
      [ngSwitch]="viewMode==='available'"
    >
      <ng-container *ngIf="purchase$ | async as purchase">
        <button
          *ngSwitchCase="true"
          [disabled]="!purchase.data"
          [routerLink]="['/dashboard', 'participant', 'reward', 'obtained']"
          class="btn btn-pollstar btn-blue"
        >
          Visualizza i tuoi premi
        </button>
      </ng-container>
      <ng-container *ngIf="reward$ | async as reward">
        <button
          *ngSwitchCase="false"
          [disabled]="!reward.data"
          [routerLink]="['/dashboard', 'participant', 'reward', 'available']"
          class="btn btn-pollstar btn-blue"
        >
          Visualizza i Premi
        </button>
      </ng-container>
    </div>

    <!-- POINTS RECAP -->
    <div class="points-recap">
      <ng-container *ngIf="point$ | async as points">
        <ng-container
          [ngSwitch]="viewMode==='available'"
        >
          <span *ngSwitchCase="true">Totale punti accumulati: {{ points.earned }} Punti</span>
          <span *ngSwitchCase="false">Totale punti spesi: {{ points.used }} Punti</span>
        </ng-container>
      </ng-container>
    </div>

    <div class="title-3 reward-category-filter-title">Filtra per categoria</div>
    <ng-container *ngIf="point$ | async as points; else rewardLoader">
      <ng-container *ngIf="reward$ | async as reward">
        <ng-container *ngIf="purchase$ | async as purchase">

          <div class="reward-available"  style="position: relative;">
            <ui-loader position="top" name="pippo"></ui-loader>
            <!-- REWARD mode-->
            <ng-container *ngIf="viewMode === 'available' && reward.data?.length > 0">
              <app-masonry [dataSource]="reward.page">
                <ng-template let-item #masonryItem>
                  <app-reward-card
                    [reward]="item"
                    [points]="points"
                    [purchases]="purchase.data"
                  ></app-reward-card>
                </ng-template>
              </app-masonry>

              <mat-paginator
                [length]="reward.data?.length"
                [pageIndex]="reward.pageIndex"
                [pageSize]="reward.pageSize"
                (page)="reward.paginate($event.pageIndex)"
                showFirstLastButtons
              >
              </mat-paginator>
            </ng-container>

            <!-- PURCHASE mode-->
            <ng-container *ngIf="viewMode === 'obtained' && purchase.data?.length > 0">
              <app-masonry [dataSource]="purchase.page">
                <ng-template let-item #masonryItem>
                  <app-reward-card
                    [reward]="item"
                    [points]="points"
                    [purchases]="purchase.data"
                    [purchase]="item"
                  ></app-reward-card>
                </ng-template>
              </app-masonry>

              <mat-paginator
                [length]="purchase.data?.length"
                [pageIndex]="purchase.pageIndex"
                [pageSize]="purchase.pageSize"
                (page)="purchase.paginate($event.pageIndex)"
                showFirstLastButtons >
              </mat-paginator>
            </ng-container>
          </div>

          <div class="reward-category-filter">
            <ng-container *ngIf="categories$ | async as categories">
              <app-reward-category-filter
                [categories]="categories"
                [dataSource]="reward.source"
                [hidden]="viewMode !== 'available'"
                (onFilter)="reward.update($event)"
              ></app-reward-category-filter>

              <app-reward-category-filter
                [categories]="categories"
                [dataSource]="purchase.source"
                [hidden]="viewMode !== 'obtained'"
                (onFilter)="purchase.update($event)"
              ></app-reward-category-filter>
            </ng-container>
          </div>

        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #rewardLoader>
      <app-card-overlay [background]="false"></app-card-overlay>
    </ng-template>

  </div>
</div>
